import {useTranslation} from 'react-i18next'
import DatePickerV2 from '../../../components/DatePickerV2/DatePickerV2'
import {TextInputV2} from '../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import './RowFilter.scss'
import {Selection} from '../../../components/Selection'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useConfigLetterModule} from '../../../hooks/useConfigLetterModule'
import {filterSelector, setFilterConfigLetter} from '../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../components/Table/Table'
import {useRoleUser} from '../../../hooks/useRoleUser'

export const RowFilter = () => {
  const {t} = useTranslation()
  const {filterConfigLetter: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {salesOrgOptions} = useSalesOrganization()
  const {options: moduleOptions} = useConfigLetterModule()
  const userRole = useRoleUser()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterConfigLetter({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      {!userRole.isSalesAnper && (
        <td>
          <Selection
            placeholder={t('Sales Org')}
            data={salesOrgOptions}
            value={filter?.sales_org_code ?? ''}
            onChange={(sales_org_code) => handleFilterChange({sales_org_code})}
          />
        </td>
      )}
      <td>
        <TextInputV2
          placeholder={t('bahasa')}
          value={filter?.lang ?? ''}
          onChange={({target}) => handleFilterChange({lang: target.value})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Module')}
          data={moduleOptions}
          value={filter?.module ?? ''}
          onChange={(module) => handleFilterChange({module})}
        />
      </td>
      <td>
        <div className='datepicker-config-letter'>
          <DatePickerV2
            placeholder={t('create_date')}
            startDate={filter?.created_at ?? ''}
            onChange={({startDate}) => handleFilterChange({created_at: startDate})}
            isSelectsRange={false}
          />
        </div>
      </td>
      <td>
        <div className='datepicker-config-letter'>
          <DatePickerV2
            placeholder={t('update_date')}
            startDate={filter?.updated_at ?? ''}
            onChange={({startDate}) => handleFilterChange({updated_at: startDate})}
            isSelectsRange={false}
          />
        </div>
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TRowFilter>
  )
}
